import Col from 'blocks/Col';
import Row from 'blocks/Row';
import { useTranslation } from 'react-i18next';
import { TierInfoCardsProps } from './tierInfoCards.interface';
import * as S from './tierInfoCards.styles';

const TierInfoCards = ({ tierMilage, rewardMilage, user, price }: TierInfoCardsProps) => {
  const { t } = useTranslation();
  return (
    <S.Wrapper>
      <S.TierInfoCard as={Row}>
        {rewardMilage != undefined && (
          <S.TierInfoMilage $color={'green'} as={Col} align="center" justify="center">
            <S.TierInfoBg style={{ backgroundImage: 'url(/passenger/images/milage-card-bg.svg)' }}></S.TierInfoBg>

            <S.TierInfoTitle>{t('pages.dashboard.infoCards.rewardMiles')}</S.TierInfoTitle>
            <S.TierInfoCount>{rewardMilage}</S.TierInfoCount>
          </S.TierInfoMilage>
        )}
        {tierMilage != undefined && (
          <S.TierInfoMilage $color={'blue'} as={Col} align="center" justify="center">
            <S.TierInfoBg style={{ backgroundImage: 'url(/passenger/images/milage-card-bg.svg)' }}></S.TierInfoBg>

            <S.TierInfoTitle>{t('pages.dashboard.infoCards.tierMiles')}</S.TierInfoTitle>
            <S.TierInfoCount>{tierMilage}</S.TierInfoCount>
          </S.TierInfoMilage>
        )}
        {user != undefined && (
          <S.TierInfoMilage $color={'green'} as={Col} align="center" justify="center">
            <S.TierInfoBg style={{ backgroundImage: 'url(/passenger/images/milage-card-bg.svg)' }}></S.TierInfoBg>

            <S.TierInfoTitle>{t('pages.dashboard.infoCards.yourReward')}</S.TierInfoTitle>
            <S.TierInfoCount>{user}</S.TierInfoCount>
          </S.TierInfoMilage>
        )}
        {price != undefined && (
          <S.TierInfoMilage $color={'gray'} as={Col} align="center" justify="center">
            <S.TierInfoBg style={{ backgroundImage: 'url(/passenger/images/milage-card-bg.svg)' }}></S.TierInfoBg>

            <S.TierInfoTitle>{t('pages.dashboard.infoCards.productPrice')}</S.TierInfoTitle>
            <S.TierInfoCount>{price}</S.TierInfoCount>
          </S.TierInfoMilage>
        )}
      </S.TierInfoCard>
    </S.Wrapper>
  );
};

export default TierInfoCards;
